export class IdGenerator {
  /** Generate nextId for new entities with number keys */
  public static generateId (): number {
    return Date.now() + IdGenerator.counter++
  }

  private static counter = 1
}
